module.exports = __webpack_public_path__ + "static/onekey-4a281d0fa9b654bd9ffad435543d1f0c.png";